import React from "react";

const TimeDropdown = ({
  handleHourChange,
  handleMinuteChange,
  selectedHour,
  selectedMinute,
}) => {
  const renderHours = () => {
    const hours = Array.from(Array(13).keys());
    return hours.map((hour) => (
      <option key={hour} value={hour}>
        {hour}
      </option>
    ));
  };

  const renderMinutes = () => {
    const minutes = [0, 15, 30, 45];
    return minutes.map((minute) => (
      <option key={minute} value={minute}>
        {minute < 10 ? `0${minute}` : minute}
      </option>
    ));
  };

  return (
    <div className="time-dropdown">
      <div>
        <label htmlFor="">Hours</label>
        <select
          className="hour-dropdown"
          value={selectedHour}
          onChange={handleHourChange}
        >
          {renderHours()}
        </select>
      </div>
      <div>
        <label htmlFor="">Minutes</label>
        <select
          className="minute-dropdown"
          value={selectedMinute}
          onChange={handleMinuteChange}
        >
          {renderMinutes()}
        </select>
      </div>
    </div>
  );
};

export default TimeDropdown;
